import axiosInstance from "../api/axiosInstance";
import { PENDING_INVOICES } from "../constants/API_URLs";

export const getPendingInvoices = (params: any): Promise<any> => {
  return axiosInstance.get(PENDING_INVOICES, { params });
};

export const getPendingInvoice = (id: any): Promise<any> => {
  return axiosInstance.get(`${PENDING_INVOICES}/${id}`);
};

export const updateCheckPanel = (id: any, data: any): Promise<any> => {
  return axiosInstance.patch(`${PENDING_INVOICES}/${id}`, data);
};

export const deletePendingInvoice = (id: any): Promise<any> => {
  return axiosInstance.delete(`${PENDING_INVOICES}/${id}`);
};

export const updatePendingInvoice = (id: any, data: any): Promise<any> => {
  return axiosInstance.patch(`${PENDING_INVOICES}/${id}`, data);
};
